import _FullInternals from "./_FullInternals";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const _FullInternals_1 = _FullInternals;
exports = _FullInternals_1.Konva;
export default exports;
export const __esModule = exports.__esModule;